import React from "react";
import { Typography, Button } from "@mui/material";
import Done from "../../Assests/Ok.svg";
import { useNavigate } from "react-router-dom";

const FinalConfirmation = ({ setClose, type, refetch, setOpenOrder }) => {
  const navigate = useNavigate()
  return (
    <div
   className="flex flex-col justify-center items-center md:h-[80vh] my-20"
      
    >
      {/* <CheckCircle size={48} color="green" style={{ marginBottom: "16px" }} /> */}
      <img src={Done} alt="Done" />

      <Typography variant="h6" fontWeight={600} mb={1}>
        {type} Request Submitted
      </Typography>
      <Typography color="textSecondary" mb={4}>
        We’re reviewing your request. We will update your status within 48 hrs.
      </Typography>

      <Button
        variant="contained"
        // onClick={() => {
        //   setOpenOrder(false);
        //   setClose(false);
        //   refetch();
        // }}
        onClick={() => navigate("/your_order")}
        sx={{
          textTransform: "none",
          backgroundColor: "#000",
          color: "#fff",
          px: 4,
          "&:hover": { backgroundColor: "#222" },
        }}
      >
        View Order
      </Button>
    </div>
  );
};

export default FinalConfirmation;
